import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.scss";
import ChallengeArena from "./pages/challenge/challenge";
import "antd/dist/antd.css";
import Home from "./pages/home/home";
import ResponseArena from "./pages/responseTime/responseTime";
import PrecisionArena from "./pages/precision/precision";
import DoubleshotArena from "./pages/doubleshot/doubleshot";
import MovingTargetsArena from "./pages/movingTargets/movingTargets";
import TargetTrackingArena from "./pages/targetTracking/targetTracking";
import Scores from "./pages/scores/scores";
import DoubleshotScores from "./pages/doubleshotScores/doubleshotScores";
import MovingTargetsScores from "./pages/movingTargetsScores/movingTargetScores";
import PrecisionScores from "./pages/precisionScores/precisionScores";
import ResponseScores from "./pages/responseTimeScores/responseTimeScores";
import TargetTrackingScores from "./pages/targetTrackingScores/targetTrackingScores";

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/aimtrainer/">
            <Home />
          </Route>
          <Route exact path="/custom-challenge-scores">
            <Scores />
          </Route>
          <Route exact path="/doubleshot-scores">
            <DoubleshotScores />
          </Route>
          <Route exact path="/moving-targets-scores">
            <MovingTargetsScores />
          </Route>
          <Route exact path="/precision-scores">
            <PrecisionScores />
          </Route>
          <Route exact path="/response-scores">
            <ResponseScores />
          </Route>
          <Route exact path="/target-tracking-scores">
            <TargetTrackingScores />
          </Route>
          <Route exact path="/custom-challenge">
            <ChallengeArena />
          </Route>
          <Route exact path="/response">
            <ResponseArena />
          </Route>
          <Route exact path="/precision">
            <PrecisionArena />
          </Route>
          <Route exact path="/doubleshot">
            <DoubleshotArena />
          </Route>
          <Route exact path="/moving-targets">
            <MovingTargetsArena />
          </Route>
          <Route exact path="/target-tracking">
            <TargetTrackingArena />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
